// extracted by mini-css-extract-plugin
export default {"warning":"VerifiedIcon-module__warning--pQoEl","success":"VerifiedIcon-module__success--ioNL5","muted":"VerifiedIcon-module__muted--YpBIW"};